import { render } from "./UGCPanelMonsterTab.vue?vue&type=template&id=5ff64df4"
import script from "./UGCPanelMonsterTab.vue?vue&type=script&lang=js"
export * from "./UGCPanelMonsterTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__